import React, { Component } from 'react';
import classNames from 'classnames/bind';
import legacyEventHub from '~/modules/legacyRuntime.js';
// import $ from 'jquery';

import UsageLicenseTypeSelect from '~/components/legacy/UsageLicenseTypeSelect.jsx';
import ProjectAddTo from '~/components/legacy/ProjectAddTo.jsx';
import { buildProjectLicenseCartRequestData, buildProjectLicenseCartRemoveRequestData, buildProjectLicenseTrackingProps } from '~/components/legacy/projectLicenseCartSelection.js';
import { trackCatalogEvent, withRankingPayload } from '~/modules/catalogEventTracking.js';
import { requestJson } from '~/modules/legacyRequest.js';

class TrackFavorite extends Component {

  constructor(props) {
    super(props);
    
    this.handleClick = this.handleClick.bind(this);
    this.playTrack = this.playTrack.bind(this);
    this.handleCartClick = this.handleCartClick.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.updateProjectLicenseFamily = this.updateProjectLicenseFamily.bind(this);
    this.removeProjectLicenseSelection = this.removeProjectLicenseSelection.bind(this);

     this.state = {
      playing: false,
      showUsageLicenseSelect: false
     };
     this.eventHubListeners = [];
  }

  formatLength(length) {
    let minutes = Math.floor((length || 0) / 60);
    let seconds = (length || 0) % 60;

    if (minutes < 10) {
      minutes = "0" + minutes;
    }

    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return minutes + ':' + seconds;
  }

  componentDidMount() {

      let that = this;

      this.registerEventHubListener('updateTrackInfo', function(data) {
          if (data[0].id !== that.props.id) {
              that.setState({
                  playing : false
              });
          }
      });

      this.registerEventHubListener('audioPlayerPlay', function(data) {
          if (data[0].id === that.props.id) {
              that.setState({
                  playing : true
              });
          }
      });


      this.registerEventHubListener('audioPlayerStop', function() {
          if (that.state.playing) {
              that.setState({
                  playing : false
              });
          }
      });

      this.registerEventHubListener('audioPlayerEnded', function() {
          if (that.state.playing) {
              that.setState({
                  playing : false
              });
          }
      });
  }

  componentWillUnmount() {
      if (!legacyEventHub || typeof legacyEventHub.off !== 'function') {
          this.eventHubListeners = [];
          return;
      }

      this.eventHubListeners.forEach(function(listener) {
          legacyEventHub.off(listener.eventName, listener.handler);
      });
      this.eventHubListeners = [];
  }

  registerEventHubListener(eventName, handler) {
      legacyEventHub.on(eventName, handler);
      this.eventHubListeners.push({ eventName: eventName, handler: handler });
  }

  handleClick(e) {
    e.preventDefault();

    return requestJson("/track_favorite?track_id=" + this.props.id, {
      method: 'POST',
      data: {}
    }).then(function(data) {
        legacyEventHub.trigger('updateTrackFavorites', data)
    }.bind(this))
  }

  playTrack(e) {
      e.preventDefault();
      legacyEventHub.trigger('playTrack', this.props.id, this.props);
      legacyEventHub.trigger('updateTrackInfo', this.props);
      this.setState({
        playing: !this.state.playing
      });
  }

  updateCart(usageLicenseTypeId, exposurePackId, forFx) {
    let itemId = this.props.id || this.state.data.id,
        i,
        updateUrl;

    if (exposurePackId) {
        updateUrl = "/cart?exposure_pack_id=" + exposurePackId + "&usage_license_type_id=" + usageLicenseTypeId;
    } else if (forFx) {
        updateUrl = "/cart?sound_effect_id=" + itemId + "&usage_license_type_id=" + usageLicenseTypeId;
    } else {
        updateUrl = "/cart?track_id=" + itemId + "&usage_license_type_id=" + usageLicenseTypeId;
    }

    return requestJson(updateUrl, {
      method: 'POST',
      data: this.cartRequestContext()
    }).then(function(data) {

      legacyEventHub.trigger('updateCart', data)

      var cartItems = data.items || data;

      // One click should emit one add_cart event, even if cartItems has duplicates.
      for (i = 0; i < cartItems.length; i += 1) {
          if (cartItems[i].track_id === itemId) {
              trackCatalogEvent('track_add_cart', { track_id: itemId, usage_license_type_id: usageLicenseTypeId, location: window.location.href });
              break;
          } else if (cartItems[i].sound_effect_id === itemId) {
              trackCatalogEvent('sound_effect_add_cart', { sound_effect_id: itemId, usage_license_type_id: usageLicenseTypeId, location: window.location.href });
              break;
          }
      }

      if (typeof fbq === 'function') {
          fbq('track', 'AddToWishlist', {
              content_ids: itemId.toString(),
              content_type: 'product',
          });
      }

    }.bind(this));
  }

  updateProjectLicenseFamily(projectLicenseSelection) {
    let itemId = this.props.id || this.state.data.id;
    const requestData = buildProjectLicenseCartRequestData(itemId, projectLicenseSelection);
    const trackingProps = buildProjectLicenseTrackingProps(itemId, projectLicenseSelection, window.location.href);

    if (!requestData) {
      return null;
    }

    return requestJson('/cart', {
      method: 'POST',
      data: { ...requestData, ...this.cartRequestContext() }
    }).then(function(data) {
      legacyEventHub.trigger('updateCart', data);

      trackCatalogEvent('track_add_cart', trackingProps);
    }.bind(this));
  }

  removeProjectLicenseSelection(projectLicenseSelection) {
    let itemId = this.props.id || this.state.data.id;
    const requestData = buildProjectLicenseCartRemoveRequestData(itemId, projectLicenseSelection);

    if (!requestData) {
      return null;
    }

    return requestJson('/cart', {
      method: 'POST',
      data: requestData
    }).then(function(data) {
      legacyEventHub.trigger('updateCart', data);
    }.bind(this));
  }


  handleCartClick(e) {
      e.preventDefault();
      this.props.handleCartClick(this.props.id);
  }

  getSelectedUsageLicenseTypeIds() {
      let ids = [],
          that = this,
          trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

      if (!Array.isArray(cart_items)) {
          return ids;
      }

      cart_items.forEach(function(element) {
          if (element.track_id === trackId) {
              ids.push(element.usage_license_type_id);
          }
      });

      return ids;
  }

  getSelectedProjectLicenseFamilyKeys() {
      let familyKeys = [],
          that = this,
          trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

      if (!Array.isArray(cart_items)) {
          return familyKeys;
      }

      cart_items.forEach(function(element) {
          if (element.track_id === trackId && element.project_license_family_key) {
              familyKeys.push(element.project_license_family_key);
          }
      });

      return familyKeys;
  }

  getSelectedProjectLicenseSelections() {
      let selections = [],
          that = this,
          trackId = this.props.id || that.state.data.id,
      cart_items = this.state.cart_items || this.props.cart_items;

      if (!Array.isArray(cart_items)) {
          return selections;
      }

      cart_items.forEach(function(element) {
          if (element.track_id === trackId && element.project_license_family_key) {
              selections.push({
                  familyKey: element.project_license_family_key,
                  usageLicenseTypeId: element.usage_license_type_id,
                  selectedOptionKeys: element.project_license_option_keys,
                  customerProjectLicensePresetId: element.customer_project_license_preset_id,
                  customerEventLicensePresetId: element.customer_event_license_preset_id,
                  projectLicensePresetName: element.project_license_preset_name
              });
          }
      });

      return selections;
  }

  cartRequestContext() {
    return withRankingPayload({ location: window.location.href }, this.state.data || this.props.data || this.props);
  }


  render() {
      let cartLinkIcon,
          usageLicenseTypeSelect,
          cartLink,
          classes,
          cartActionLabel,
          removeLabel;

      usageLicenseTypeSelect = (
          <UsageLicenseTypeSelect
          locale={this.props.locale}
          addToCart={this.props.locale === 'de' ? 'zum Warenkorb hinzufügen' : 'add to cart'}
          free={this.props.free}
          discount={this.props.discount}
          subscribedUsageLicenseTypes={this.props.subscribedUsageLicenseTypes}
          usageLicenseTypes={this.props.usageLicenseTypes}
          updateCart={this.updateCart}
          updateProjectLicenseFamily={this.updateProjectLicenseFamily}
          removeProjectLicenseSelection={this.removeProjectLicenseSelection}
          pricing_path={this.props.pricing_path}
          licenseNavigatorPath={this.props.licenseNavigatorPath}
          selectionMode='project_license_family'
          i18n={this.props.i18n}
          visible={this.props.showUsageLicenseSelect}
          selectedUsageLicenseTypeIds={this.getSelectedUsageLicenseTypeIds()}
          selectedProjectLicenseFamilyKeys={this.getSelectedProjectLicenseFamilyKeys()}
          selectedProjectLicenseSelections={this.getSelectedProjectLicenseSelections()}
          cartItems={this.state.cart_items || this.props.cart_items}
          position='overlay'
          show_download_button={this.props.show_download_button}
          handleCartClick={this.handleCartClick}
          onRequestClose={this.handleCartClick}
          trackTitle={this.props.title} />
      );

      cartActionLabel = this.props.inCart
        ? (this.props.remove_from_cart || (this.props.locale === 'de' ? 'Aus Warenkorb entfernen' : 'Remove from cart'))
        : (this.props.add_to_cart || (this.props.locale === 'de' ? 'Zum Warenkorb hinzufügen' : 'Add to cart'));
      removeLabel = this.props.locale === 'de' ? 'Entfernen' : 'Remove';
      const licenseLabel = this.props.locale === 'de' ? 'Lizenz wählen' : 'Choose license';
      const formattedLength = this.props.length ? this.formatLength(this.props.length) : null;

      if (this.props.inCart) {
          if (this.props.show_download_button) {
          cartLinkIcon = <span className='track-favorites__cart-link-icon'><i className="fa fa-download"></i></span>;
          } else {
          cartLinkIcon = <span className='track-favorites__cart-link-icon'><i className="track-favorites__cart-link-icon-added fa fa-check"></i><i className="fa fa-shopping-cart track-favorites__cart-link-icon-cart"></i></span>;
          }
          cartLink = <a className="track-favorites__action-button-added-to-cart" href="#" onClick={this.handleCartClick} aria-label={cartActionLabel} title={cartActionLabel}>{cartLinkIcon}</a>
      } else {
          if (this.props.show_download_button) {
              cartLinkIcon = <span className='track-favorites__cart-link-icon'><i className="fa fa-download"></i></span>;
          } else {
              cartLinkIcon = <span className='track-favorites__cart-link-icon'><i className="track-favorites__cart-link-icon-add fa fa-plus"></i><i className="fa fa-shopping-cart track-favorites__cart-link-icon-cart"></i></span>;
          }
          cartLink = <a className="track-favorites__action-button-add-to-cart" href="#" onClick={this.handleCartClick} aria-label={cartActionLabel} title={cartActionLabel}>{cartLinkIcon}</a>
      }

      classes = classNames({
          'track-favorites__item': true,
          'track--active': this.props.active,
          'track-favorites__item--license-select-open': this.props.showUsageLicenseSelect
      });

      return (
        <div className={classes}>
          <div className="track-favorites__item-content">
            <div className='track-favorites__item-main'>
              <a href="#" onClick={this.playTrack} className='track-favorites__item-play-icon'>
                {this.props.track_image_markup ? (
                  <div className='track-favorites__item-image' dangerouslySetInnerHTML={{__html: this.props.track_image_markup}} />
                ) : null}
                <span>
                  <i className={this.state.playing ? 'fa fa-pause' : 'fa fa-play' } />
                </span>
              </a>
              <div className='track-favorites__item-name'>
                <div className='track-favorites__item-title-row'>
                  <a href={this.props.showcase_url || '#'} className='track-favorites__item-title'>
                    <span className='track-favorites__item-id'>{this.props.id}</span>
                    {this.props.title}
                  </a>
                  {formattedLength ? (
                    <span className='track-favorites__item-length'>{formattedLength}</span>
                  ) : null}
                </div>
                {this.props.composer_name ? (
                  <div className='track-favorites__item-artist'>{this.props.composer_name}</div>
                ) : null}
                <div className='track-favorites__item-actions-secondary'>
                  <ProjectAddTo
                    actionId={`favorite-project-action-${this.props.id}`}
                    customerSignedIn={this.props.customerSignedIn}
                    enabled={true}
                    locale={this.props.locale}
                    portalClassName='catalog-project-action__portal--favorites'
                    trackId={this.props.id}
                    trackTitle={this.props.title}
                    analyticsSurface='favorites'
                  />
                  <a href="#" onClick={this.handleClick} className='track-favorites__item-remove' aria-label={removeLabel}>
                    {removeLabel}
                  </a>
                </div>
              </div>
            </div>
            <div className='track-favorites__item-side'>
              <div className="track-favorites__cart-link">
                {cartLink}
                <span className='track-favorites__item-side-label'>{licenseLabel}</span>
              </div>
            </div>
          </div>
          {usageLicenseTypeSelect}
        </div>
      )
  }
};

TrackFavorite.defaultProps = {
  cart_items : []
}

export default TrackFavorite;
